/**
 *  @prop --cbp-floating-action-z-index: var(--cbp-z-index-level-4);
 *  @prop --cbp-floating-action-box-shadow: var(--cbp-shadow-level-2-center);
 */
:root {
  --cbp-floating-action-z-index: var(--cbp-z-index-level-4);
  --cbp-floating-action-box-shadow: var(--cbp-shadow-level-2-center);
}

cbp-floating-action {
  position: fixed; 
  z-index: var(--cbp-floating-action-z-index);

  /** Add box-shadow to slotted buttons. */
  cbp-button{
    button, a{
      box-shadow: var(--cbp-floating-action-box-shadow),
    }
  }
}